import { GET_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetProcedureStatusList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/ProcedureReport/GetList?` + params, null);
